export function areCommentsVisible(state) {
    return state.comment.areVisible && !state.deviceDetection.isMobile;
}
